import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  allPropertyTypes: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  propertyCategoriesByType: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  propertySubCategory: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  allMyPropertyLists: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  viewPropertyListing: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  userWishlistListing: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },

  userMyScheduleVisitsListing: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },

  singlePropertyDetail: {
    error: {
      isError: false,
      message: "",
    },
    items: null,
    loading: false,
  },
  postPropertyData: {
    items: {},
    postPropertyStep: 1,
  },
  historyDataListing: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  notificationsDataListing: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  singleAgentPropertyDetail: {
    error: {
      isError: false,
      message: "",
    },
    items: null,
    loading: false,
  },
  agentNotificationsDataListing: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  propertyRatingData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
};

export const userDashboardSlice = createSlice({
  name: "userDashboardData",
  initialState,
  reducers: {
    setAllPropertyTypesData: (state, action) => {
      state.allPropertyTypes.items = action.payload;
    },
    setAllPropertyTypesDataLoading: (state, action) => {
      state.allPropertyTypes.loading = action.payload;
    },
    setAllPropertyTypesDataError: (state, action) => {
      state.allPropertyTypes.error = action.payload;
      state.allPropertyTypes.items = [];
    },
    setPropertyCategoryByTypeData: (state, action) => {
      state.propertyCategoriesByType.items = action.payload;
    },
    setPropertyCategoryByTypeDataLoading: (state, action) => {
      state.propertyCategoriesByType.loading = action.payload;
    },
    setPropertyCategoryByTypeDataError: (state, action) => {
      state.propertyCategoriesByType.error = action.payload;
      state.propertyCategoriesByType.items = [];
    },
    setPropertySubCategoryData: (state, action) => {
      state.propertySubCategory.items = action.payload;
    },
    setPropertySubCategoryDataLoading: (state, action) => {
      state.propertySubCategory.loading = action.payload;
    },
    setPropertySubCategoryDataError: (state, action) => {
      state.propertySubCategory.error = action.payload;
      state.propertySubCategory.items = [];
    },
    setPostPropertyData: (state, action) => {
      state.postPropertyData.items = action.payload;
    },
    setPostPropertyStepCount: (state, action) => {
      state.postPropertyData.postPropertyStep = action.payload;
    },
    setAllMyPostPropertyData: (state, action) => {
      state.allMyPropertyLists.items = action.payload;
    },
    setAllMyPostPropertyDataLoading: (state, action) => {
      state.allMyPropertyLists.loading = action.payload;
    },
    setAllMyPostPropertyDataError: (state, action) => {
      state.allMyPropertyLists.error = action.payload;
      state.allMyPropertyLists.items = [];
    },
    setSinglePropertyDetail: (state, action) => {
      state.singlePropertyDetail.items = action.payload;
    },
    setSinglePropertyDetailLoading: (state, action) => {
      state.singlePropertyDetail.loading = action.payload;
    },
    setSinglePropertyDetailError: (state, action) => {
      state.singlePropertyDetail.error = action.payload;
      state.singlePropertyDetail.items = null;
    },
    setAgentSinglePropertyDetailLoading: (state, action) => {
      state.singleAgentPropertyDetail.loading = action.payload;
    },
    setAgentSinglePropertyDetailError: (state, action) => {
      state.singleAgentPropertyDetail.error = action.payload;
      state.singleAgentPropertyDetail.items = null;
    },
    setAgentSinglePropertyDetail: (state, action) => {
      state.singleAgentPropertyDetail.items = action.payload;
      state.singleAgentPropertyDetail.loading = false;
    },

    setViewPropertyListingData: (state, action) => {
      state.viewPropertyListing.items = action.payload;
    },
    setViewPropertyListingLoading: (state, action) => {
      state.viewPropertyListing.loading = action.payload;
    },
    setViewPropertyListingError: (state, action) => {
      state.viewPropertyListing.error = action.payload;
      state.viewPropertyListing.items = [];
    },
    setUserWishlistListingData: (state, action) => {
      state.userWishlistListing.items = action.payload;
    },
    setUserWishlistListingLoading: (state, action) => {
      state.userWishlistListing.loading = action.payload;
    },
    setUserWishlistListingError: (state, action) => {
      state.userWishlistListing.error = action.payload;
      state.userWishlistListing.items = [];
    },

    setUserMyScheduleVisitsListingData: (state, action) => {
      state.userMyScheduleVisitsListing.items = action.payload;
    },
    setUserMyScheduleVisitsListingLoading: (state, action) => {
      state.userMyScheduleVisitsListing.loading = action.payload;
    },
    setUserMyScheduleVisitsListingError: (state, action) => {
      state.userMyScheduleVisitsListing.error = action.payload;
      state.userMyScheduleVisitsListing.items = [];
    },
    setUserHistoryData: (state, action) => {
      state.historyDataListing.items = action.payload;
    },
    setUserHistoryDataLoading: (state, action) => {
      state.historyDataListing.loading = action.payload;
    },
    setUserHistoryDataError: (state, action) => {
      state.historyDataListing.error = action.payload;
      state.historyDataListing.items = [];
    },
    setUserNotificationsData: (state, action) => {
      state.notificationsDataListing.items = action.payload;
    },
    setUserNotificationsDataLoading: (state, action) => {
      state.notificationsDataListing.loading = action.payload;
    },
    setUserNotificationsDataError: (state, action) => {
      state.notificationsDataListing.error = action.payload;
      state.notificationsDataListing.items = [];
    },
    setAgentNotificationsData: (state, action) => {
      state.agentNotificationsDataListing.items = action.payload;
    },
    setAgentNotificationsDataLoading: (state, action) => {
      state.agentNotificationsDataListing.loading = action.payload;
    },
    setAgentNotificationsDataError: (state, action) => {
      state.agentNotificationsDataListing.error = action.payload;
      state.agentNotificationsDataListing.items = [];
    },
    setPropertyRatingData: (state, action) => {
      state.propertyRatingData.items = action.payload;
    },
    setPropertyRatingDataLoading: (state, action) => {
      state.propertyRatingData.loading = action.payload;
    },
    setPropertyRatingDataError: (state, action) => {
      state.propertyRatingData.error = action.payload;
      state.propertyRatingData.items = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setAllPropertyTypesData,
  setAllPropertyTypesDataLoading,
  setAllPropertyTypesDataError,
  setPropertyCategoryByTypeData,
  setPropertyCategoryByTypeDataLoading,
  setPropertyCategoryByTypeDataError,
  setPropertySubCategoryData,
  setPropertySubCategoryDataLoading,
  setPropertySubCategoryDataError,
  setPostPropertyData,
  setPostPropertyStepCount,
  setAllMyPostPropertyData,
  setAllMyPostPropertyDataLoading,
  setAllMyPostPropertyDataError,
  setSinglePropertyDetail,
  setSinglePropertyDetailLoading,
  setSinglePropertyDetailError,
  setViewPropertyListingData,
  setViewPropertyListingLoading,
  setViewPropertyListingError,

  setUserWishlistListingData,
  setUserWishlistListingLoading,
  setUserWishlistListingError,

  setUserMyScheduleVisitsListingData,
  setUserMyScheduleVisitsListingLoading,
  setUserMyScheduleVisitsListingError,
  setUserHistoryData,
  setUserHistoryDataError,
  setUserHistoryDataLoading,
  setUserNotificationsData,
  setUserNotificationsDataError,
  setUserNotificationsDataLoading,
  setAgentSinglePropertyDetail,
  setAgentSinglePropertyDetailLoading,
  setAgentSinglePropertyDetailError,
  setAgentNotificationsData,
  setAgentNotificationsDataError,
  setAgentNotificationsDataLoading,
  setPropertyRatingData,
  setPropertyRatingDataError,
  setPropertyRatingDataLoading,
} = userDashboardSlice.actions;

export default userDashboardSlice.reducer;

export const userDashboardSelector = (state) => state.userDashboardData;
